import React, { Children } from 'react'

import Icon from 'components/Icon'

import classNames from 'helpers/css'

import styles from './index.module.scss'

const Stepper: React.FC<StepperProps> = ({ children, currentStep }) => {
  const arrayChildren = Children.toArray(children)

  return (
    <div className={classNames(styles, 'contact-request-form__stepper')}>
      {Children.map(arrayChildren, (child, index) => {
        let arrowState = 'disabled'
        let state = 'disabled'

        if (index < currentStep - 1) {
          state = 'done'
          arrowState = 'done'
        } else if (index === currentStep - 1) {
          state = 'active'
        }

        return (
          <span
            key={index}
            className={classNames(styles, `contact-request-form__stepper__step--${state}`)}
          >
            {child}
            {index < arrayChildren.length - 1 && (
              <Icon
                name="angle-right"
                className={classNames(styles,
                  `contact-request-form__stepper__arrow contact-request-form__stepper__arrow--${arrowState}`,
                )}
              />
            )}
          </span>
        )
      })}
    </div>
  )
}

type StepperProps = {currentStep : number}

export default Stepper
